import { trigger, state, style, transition, animate } from "@angular/animations";

export const fadeInOutAnimation = [
  trigger("fadeInOut", [
    state("in", style({ opacity: 1 })),
    transition(":enter", [style({ opacity: 0 }), animate("150ms ease-in")]),
    transition(":leave", [animate("300ms ease-out", style({ opacity: 0 }))]),
  ]),
];
